var render = function render(){var _vm=this,_c=_vm._self._c;return _c('forms-input',{staticClass:"forms-search",attrs:{"autofocus":_vm.autofocus,"clearable":"","icon-pre":"search","placeholder":_vm.placeholder,"size":_vm.$pepper.Size.S},on:{"input":(value) => _vm.$emit('search', value)},model:{value:(_vm.iValue),callback:function ($$v) {_vm.iValue=$$v},expression:"iValue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }